import { SuspenseFallback } from '@/components/suspense-fallback/SuspenseFallback';
import { Modal } from 'aui';
import styles from './modal.module.less';
import React, { Suspense } from 'react';

const LazySchemaGenerator = React.lazy(() => import('./modal'));

export function AsyncSchemaGeneratorModal(
  props: React.ComponentProps<
    typeof LazySchemaGenerator & {
      visible: boolean;
      onCancel: () => void;
    }
  >,
) {
  if (!props.visible) {
    return null;
  }
  return (
    <Modal
      footer={null}
      onCancel={props.onCancel}
      className={styles.schemaGeneratorModal}
      destroyOnClose
      centered
      maskClosable={true}
      open={props.visible}
      size={'960'}
    >
      <Suspense fallback={<SuspenseFallback className='p-10 h-[600px]' />}>
        <LazySchemaGenerator {...props} />
      </Suspense>
    </Modal>
  );
}
